import { cn } from "@/lib/utils";
import { ChevronLeft } from "lucide-react";

interface AuthBackLinkProps {
    label: string;
    onClick: () => void;
    className?: string;
}

/** Standard back navigation for auth sub-flows (OTP, verify steps). */
export function AuthBackLink({ label, onClick, className }: AuthBackLinkProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                "inline-flex items-center gap-1 self-start text-muted-foreground hover:text-foreground text-sm transition-colors",
                className
            )}
        >
            <ChevronLeft aria-hidden className="size-4 shrink-0" />
            {label}
        </button>
    );
}
